export const SET_SEARCH = 'SET_SEARCH';

export const setSearch = search => ({
    type: SET_SEARCH,
    payload: search,
});
